export enum InsuranceTypes {
  Renewal,
  OwnershipTransfer,
  CustomCard,
  Sequance,
}
